import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { localizedPath } from "../../utils/lang";

// Drop-in replacement for react-router's <Link> that prefixes internal, absolute
// app paths ("/blog") with the active language segment ("/fr/blog"). External
// links (http...), anchors (#...) and already-prefixed paths pass through.
const isInternal = (to) =>
  typeof to === "string" && to.startsWith("/") && !to.startsWith("//");

const LocalizedLink = ({ to, children, ...rest }) => {
  const { lang } = useLanguage();
  const target = isInternal(to) ? localizedPath(lang, to) : to;
  return (
    <Link to={target} {...rest}>
      {children}
    </Link>
  );
};

export default LocalizedLink;
